export const allSftpOptions = [
  { label: "Success", value: "success" },
  { label: "Resubmit", value: "resubmit" },
  { label: "Not Sent", value: "" },
  { label: "Error", value: "error" },
];
